import Modal from '@components/common/Modal';
import TransferForm from './TransferForm';

/**
 * Modal de transferência entre contas. Também é o fluxo de "pagar fatura"
 * (origem = conta corrente, destino = cartão de crédito).
 */
const TransferModal = ({ isOpen, onClose, accounts, transfer, isTransferring, defaultValues }) => {
  const handleSubmit = async (data) => {
    try {
      await transfer(data);
      onClose();
    } catch {
      // erro já é tratado com toast no useAccounts (transferMutation.onError)
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Transferência entre contas" size="md">
      <TransferForm
        accounts={accounts}
        defaultValues={defaultValues}
        onSubmit={handleSubmit}
        onCancel={onClose}
        isLoading={isTransferring}
      />
    </Modal>
  );
};

export default TransferModal;
